import { defaultColumns, defaultSort } from '../../components/imports/columns';

export default {
  state: {
    imports: [],
    importData: {},
    paginatedImports: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    pageCount: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    imports: state => state.imports,
    importData: state => state.importData,
    paginatedImports: state => state.paginatedImports,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
    pageCount: state => state.pageCount,
  },
  mutations: {
    setImports(state, imports) {
      state.imports = imports;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setPaginatedImports(state, paginatedImports) {
      state.paginatedImports = paginatedImports
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setImportData(state, importData) {
      state.importData = importData;
    },
    setPageCount(state, pageCount) {
      state.pageCount = pageCount;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/imports-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'imports-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }) {
      commit('setLoading', true);
      try {
        const imports = await axios.get('api/imports');
        commit('setImports', imports);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      commit('setPaginatedImports', []);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }

        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const imports = await axios.get('api/imports/paginated' + (query || ''));
        commit('setCurrentPage', imports.current_page);
        commit('setPaginatedImports', imports);
        commit('setPageCount', imports.last_page);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      const importData = await axios.get(`api/imports/${id}`);
      commit('setImportData', importData)
      return importData
    },

    async download({ commit }, id) {
      try {
        this.loading = true;
        const csv = await axios({
          url: `api/imports/download/${id}`,
          method: 'GET',
          responseType: 'blob',
        });
        saveAs(csv, 'import.csv');
        this.loading = false;
      } catch (e) {
        console.error(e)
        this.loading = false;
      }
    }
  },
};
